import React, { Component } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Loader from 'react-loader';
import { COLORS, TEMPLATE_COVERAGE, EDIT_TEMPLATE_COVERAGE} from '../utils/constants';
import edit from '../resources/images/estrategas/tools/edit.svg';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import * as Request from '../service/data-info-chart/requestsUtil';


class TemplateCoverage extends Component {

  constructor(props){
    super(props);
    this.toggle = this.toggle.bind(this);
    this.editActions = this.editActions.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state={ loaded: true, data: [], modal: false, minGoal: null,
      currentGoal: null, goal: null, key: 1, minGoalprev: null, goalprev: null, currentGoalprev: null}
  }

  componentDidMount(){
    this.getFetch()
  }

  toggle(){
    this.setState({modal: !this.state.modal})
  }

  postFetch(params){
    Request.postFetch(EDIT_TEMPLATE_COVERAGE, params).then(
      this.getFetch()
    );
  }

  getFetch(){
    Request.getFetch(TEMPLATE_COVERAGE+this.props.date).then(resp=>{
      const i = resp.length-1;
      this.setState({data:resp, minGoalprev: resp[i].minimunGoal, currentGoalprev: resp[i].actualGoal,
        goalprev: resp[i].goal, loaded: true, key: Math.random()})
    });
  }

  editActions() {
    this.setState({ loaded: false });

    let minGoal = (this.state.minGoal!=null&&this.state.minGoal!==""&&!isNaN(this.state.minGoal)&&0<this.state.minGoal<=100&&this.state.minGoal>=0)
      ?this.state.minGoal:this.state.minGoalprev;
    let currentGoal = (this.state.currentGoal!=null&&this.state.currentGoal!==""&&!isNaN(this.state.currentGoal)&&0<this.state.currentGoal<=100&&this.state.currentGoal>=0)
      ?this.state.currentGoal:this.state.currentGoalprev;
    let goal = (this.state.goal!=null&&this.state.goal!==""&&!isNaN(this.state.goal)&&this.state.goal<=100&&this.state.goal>=0)
      ?this.state.goal:this.state.goalprev;

    let params = {
      'minimunGoal': minGoal,
      'actualGoal': currentGoal,
      'goal': goal,
      'date': this.props.date
    };
    this.toggle();
    this.postFetch(params);
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({ [name]: value });
  }


  render(){
    let classUser = this.props.authorization ? 'quality-edit' : 'quality-edit-unauthorized';
    return(
      <div className='container-fluid back-color-grey {/*margin-fix-top*/}'>
        <div className={classUser}>
          <img src={edit} title="Editar" alt=" " onClick={this.toggle}/>
        </div>
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader className='header-modal'
                       toggle={this.toggle}>Periodo {this.props.dateModal}</ModalHeader>
          <ModalBody>
            <div className='d-flex justify-content-end  m-3'>
              <p className='mb-0 mr-2'>Resultado:</p>
              <Input placeholder="% porcentaje" type="text" name="minGoal" id="minGoal"
                     value={this.state.minGoal} onChange={this.handleChange}
                     style={{ width: '50%' }}/>
            </div>
            <div className='d-flex justify-content-end m-3'>
              <p className='mb-0 mr-2'>Objetivo:</p>
              <Input placeholder="% porcentaje" type="text" name="currentGoal" id="currentGoal"
                     value={this.state.currentGoal} onChange={this.handleChange}
                     style={{ width: '50%' }}/>
            </div>
           {/* <div className='d-flex justify-content-end m-3'>
              <p className='mb-0 mr-2'>Meta a alcanzar:</p>
              <Input placeholder="% porcentaje" type="text" name="goal" id="goal"
                     value={this.state.goal} onChange={this.handleChange}
                     style={{ width: '50%' }}/>
            </div>*/}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.editActions}>Aceptar</Button>{' '}
            <Button color="danger" onClick={this.toggle}>Cancelar</Button>
          </ModalFooter>
        </Modal>
        <div className='container-fluid hum-res-title-1'>
          Cobertura de plantilla
        </div>
        <div className='m-md-5 m-sm-0' key={this.state.key}>
          <Loader loaded={this.state.loaded} top={'60%'}/>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart width={1200} height={300} data={this.state.data}
                       margin={{top: 5, right: 30, left: 20, bottom: 5}}>
              <XAxis dataKey="date"/>
              <YAxis type="number" domain={[0, 100]} label={{ value: "Porcentaje(%)", angle: -90, position: 'insideLeft' }}/>
              <CartesianGrid strokeDasharray="3 3"/>
              <Tooltip/>
              <Legend verticalAlign={'top'}/>
              {/*<Line type="linear" name={"Meta"} dataKey="goal" stroke={COLORS.GOAL}/>*/}
              <Line type="linear" name={"Resultado"} dataKey="actualGoal" stroke={COLORS.AMOUNT}/>
              <Line type="linear" name={"Objetivo"} dataKey="minimunGoal" stroke={COLORS.BASE}/>
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}

export default TemplateCoverage;



// WEBPACK FOOTER //
// ./src/charts/templateCoverage.js